<template lang="pug">
  .text-plus-input
    .document-box(v-if="loading == false")
      .document-single(v-for="document in data" v-bind:class="{ active: (document.assigned == true) }" @click="toggleDocument(document.id)")
        .pad
          span {{ document.name }}
        .tag-container
          span.tag {{ document.is_template === false ? 'Bespoke Document' : 'Template' }}
          span.tag {{ document.requires_premium === true ? '£' : 'Free' }}
</template>

<script>
// intended for network reqeusts to existing users only.
import DocumentService from '@/services/document'

export default {
  data: function() {
    return {
      value: '',
      data: [],
      loading: true
    }
  },
  props: ['title','placeholder','user'],
  methods: {
    async GET_DATA() {
      try {
        this.loading = true;
          const response = await DocumentService.get_premium({ user_id: this.user });
          if(response) {
            if(response.data)
              this.$emit('success', response.data);
            return true;
          }
      } catch(err) {
        this.loading = false;
      }
    },
    async toggleDocument(id) {

      this.data.forEach((doc, index) => {
        if(doc.id == id) {
          const is_assigned = this.data[index].assigned;

          DocumentService.toggle_user({ user_id: this.user, document_id: id })
            .then(response => {
            if(response.data)
              // console.log(response.data);
              this.data[index].assigned = !this.data[index].assigned;
            })
        }
      })
    }
  },
  created() {
    this.$on('loading', function (e) {
      this.loading = e;
    });
    this.$on('error', function (e) {
      this.error = e;
    });
    this.$on('success', function (e) {
      this.loading = false;
      this.data = e;
      this.error = '';
    });
    // console.log('documentBox created');
    this.GET_DATA();
  }
}
</script>

<style lang="scss" scoped>
  .document-box {
    margin-top:13px;
    max-height:485px;
    overflow:hidden;
    overflow-y: scroll;
  }
  .document-single {
    &.active {
      background-image: url('~@/assets/images/tick-circle-white.svg');
      background-color: rgba(40,200,10, 0.34);
    }
    &.active:nth-child(even) {
      background-color: rgba(40,200,10, 0.42);
    }
    background-color: rgba(255,255,255,0.05);  
    background-repeat:no-repeat;
    background-position:center right 12px;
    background-size:16px;
    &:nth-child(even) {
      background-color: rgba(255,255,255,0.22);  
    }
    &:hover {
      cursor:pointer;
      background-color: rgba(255,255,255,0.37);  
    }
    width:100%;
    position:relative;
    .pad {
      line-height:40px;
      text-indent:14px;
      font-size:13px;
      display:inline-block;
    }
    .tag-container {
      float:right;
      margin-right:42px;
      .tag {
        margin-left:4px;
        margin-top:10px;
        padding: 4px 8px;
        text-indent:0px;
        text-align:center;
        float:right;
        color:#222;
        background:rgba(255,255,255,0.7);
        border-radius:7px;
        font-size:11px;
      }
    }
    span {
      color:#eee;
    }
  }
</style>